var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled, css } from '@creditas-ui/system';
import { ifProp, variant } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
var disabled = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  user-select: none;\n\n  :hover {\n    box-shadow: none;\n  }\n"])));

var base = _ref => {
  var {
    theme: {
      tag
    }
  } = _ref;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  padding: 0 ", ";\n  border-radius: ", ";\n\n  :hover {\n    box-shadow: ", ";\n  }\n"])), tag('base.container.paddingX'), tag('base.container.borderRadius'), tag('base.container.shadow'));
};

var sizes = _ref2 => {
  var {
    theme: {
      tag
    }
  } = _ref2;
  return variant({
    prop: 'size',
    variants: {
      small: {
        paddingTop: tag('size.small.container.paddingY'),
        paddingBottom: tag('size.small.container.paddingY')
      },
      medium: {
        paddingTop: tag('size.medium.container.paddingY'),
        paddingBottom: tag('size.medium.container.paddingY')
      }
    }
  });
};

var colors = _ref3 => {
  var {
    theme: {
      tag
    }
  } = _ref3;
  return variant({
    prop: 'color',
    variants: {
      primary: tag('color.primary'),
      secondary: tag('color.secondary')
    }
  });
};

var TagElement = styled(Box.withComponent('span', process.env.NODE_ENV === "production" ? {
  target: "e1wwp30v0"
} : {
  target: "e1wwp30v0",
  label: "TagElement"
}))(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"])), base, colors, sizes, ifProp('disabled', disabled));
export { TagElement };
//# sourceMappingURL=Tag.style.js.map